import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ css, token }) => {
  return {
    opportunityStatuses: css`
      max-height: 400px;
      overflow: auto;
      box-shadow: ${token.boxShadow};
    `
  }
})
